import { render, staticRenderFns } from "./ArrowCaretIcon.vue?vue&type=template&id=f81f12a8&scoped=true&"
import script from "./ArrowCaretIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowCaretIcon.vue?vue&type=script&lang=js&"
import style0 from "./ArrowCaretIcon.vue?vue&type=style&index=0&id=f81f12a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81f12a8",
  null
  
)

export default component.exports